import React, { useEffect, useState } from 'react';
import { getInstructorId,getAllThesisAssigned } from '../../services/thesisAssignedService';
import { getAllExaminerFeedbacks } from '../../services/feedbackService';
import { Link } from "react-router-dom";
import "./datatable.scss"
import { DataGrid } from '@mui/x-data-grid';
import axiosInstance from '../../api/axios';
import { toast } from 'react-toastify';
import { useLocation } from "react-router-dom";
import VivaChatWidget from "./VivaChatWidget";
import { isSlotActive } from "../../hooks/ChatUtils";

export const ThesisAssignedList=()=> {
    const [thesis, setThesis] = useState([]);
    
    const [instructorId, setInstructorId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [file, setFile] = useState(null);
    const examinerId = localStorage.getItem('examinerId');
    const location = useLocation();
    const [vivaIds, setVivaIds] = useState([]);

    const [showSlotButton, setShowSlotButton] = useState(false);

 /*   const fetchThesis = async () => {
        try {
           
                if(examinerId!=-1){
                    const data = await getAllThesisAssigned(examinerId);
                    setThesis(data.data);
                }
           
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };

   */ 

    // Temporarily disabled: /slotSelectionStatus has no backend endpoint yet.
    // useEffect(() => {
    //     axiosInstance.get("/slotSelectionStatus")
    //         .then(res => {
    //             setShowSlotButton(res.data.data);
    //         })
    //         .catch(() => {
    //             setShowSlotButton(false);
    //         });
    // }, []);

   

const fetchThesis = async () => {
    try {
        if (examinerId != -1) {
            const data = await getAllThesisAssigned(examinerId);
            const feedback = await getAllExaminerFeedbacks(examinerId);
            const feedbackList = feedback.data;
            const thesisList = data.data;
           // console.log(feedbackList);
           // console.log(examinerId)
            // Merge feedback with thesis
            const merged = thesisList.map(thesis => {
                const fb = feedbackList.find(
                    f => f.thesis_status_id === thesis.id //&&
                     //    f.examiner_id === examinerId
                );

                return {
                    ...thesis,
                    feedbackId: fb ? fb.id : null,
                 //   feedback: fb || null     // optional: full feedback
                };
            });
           // console.log(merged);
            setThesis(merged);
            const ids = data.data
        .map(d => d.vivaId)
        .filter(id => id != null);

      setVivaIds(ids);
        }
    } catch (err) {
        setError(err);
    } finally {
        setLoading(false);
    }
};



    
    useEffect(() => {
        
        fetchThesis();
    }, []);

    const [slots, setSlots] = useState([]);

    const enrichedSlots = slots.map(slot => ({
    ...slot,
    students: thesis.filter(r => slot.vivaIds?.includes(r.vivaId))
    }));

    useEffect(() => {
    fetchSlots();
    }, [vivaIds]);
        
    const fetchSlots = async () => {
    try {
        if (!vivaIds.length) return;

        const params = new URLSearchParams();
        vivaIds.forEach(id => params.append("vivaIds", id));

        const res = await axiosInstance.get(`/viva/slots?${params.toString()}`);

        setSlots(res.data?.data || []);
    } catch (err) {
        console.error(err);
    }
    };

    const handleLinkClick = (url) => {
        window.open(url, '_blank', 'noopener,noreferrer');
      };

    const columns = React.useMemo(
        () => [
            { field: 'thesis_title', headerName: 'Title', width: 200 },
            { field: 'student_name', headerName: 'Student Name', width: 150 },
            { field: 'enrollment_number', headerName: 'Enrollment Number', width: 150 },
            {
              field: 'combined_report', 
              headerName: 'Report Type', 
              width: 180, 
              renderCell: (params) => {
                const reportType = params.row?.report_type || '';
                const reportMonth = params.row?.report_month || '';
                if(reportType=='ProjectProposal')
                  return 'Project Proposal'
                return `${reportType}  ${reportMonth}`;
              },
            },
            { field: 'term_type', headerName: 'Term Type', width: 150 },
            
            {
                field: "vivaSchedule",
                headerName: "Viva Schedule",
                width: 260,
                renderCell: (params) => {
                const { date, startTime, endTime } = params.row || {};

                if (!date || !startTime || !endTime) {
                    return <span style={{ color: "#999" }}>Not Scheduled</span>;
                }

                return (
                    <div style={{ lineHeight: "18px" }}>
                    <div style={{ fontWeight: 600 }}>{date}</div>
                    <div style={{ fontSize: 12, color: "#555" }}>
                        {startTime} – {endTime}
                    </div>
                    </div>
                );
                },
            },
            // {
            //         field: 'rebuttal_report_link', headerName: 'Rebuttal Report Link', width: 250, renderCell: (params) => (
            //           <div style={{ display: 'flex', alignItems: 'center' }}>
            //             <Link
            //               href={params.value}
            //               onClick={(event) => handleLinkClick(params.value, event)}
            //               style={{
            //                 color: 'blue',
            //                 textDecoration: 'underline',
            //                 marginRight: '10px',
            //                 cursor: 'pointer',
            //               }}
            //             >
            //               {params.value}
            //             </Link>
            //           </div>
            //         ),
            //       }
            
        //     { field: 'folder_link', headerName: 'Folder Link', width: 250 ,renderCell: (params) => (
        //         <div style={{ display: 'flex', alignItems: 'center' }}>
        //         <Link
        //           href={params.value}
        //           onClick={(event) => handleLinkClick(params.value, event)}
        //           style={{
        //             color: 'blue',
        //             textDecoration: 'underline',
        //             marginRight: '10px',
        //             cursor: 'pointer',
        //           }}
        //         >
        //           {params.value}
        //         </Link>
        //       </div>
        //     ),
        // },
            
        ],
        []
    );

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;

    const actionColumn = [{ field: "action", headerName:"Feedback (Form with Submitted Files and Previous Feedback)", width:425,
        renderCell:(params)=>{
            const { id ,student_id,reviewer_id1, reviewer_id2,is_feedback_by_reviewer1,is_feedback_by_reviewer2,examiner_id1, examiner_id2,is_feedback_by_examiner1,is_feedback_by_examiner2, codeExaminerId, is_feedback_by_code_examiner, feedbackId, share_to_student} = params.row;

           // console.log(share_to_student, id, feedbackId);
            return(
                <div className="cellAction">
                    {((reviewer_id1==parseInt(localStorage.getItem('examinerId'),10) && !is_feedback_by_reviewer1) ||
                    (reviewer_id2==parseInt(localStorage.getItem('examinerId'),10) && !is_feedback_by_reviewer2) ||
                    (examiner_id1==parseInt(localStorage.getItem('examinerId'),10) && !is_feedback_by_examiner1) ||
                    (examiner_id2==parseInt(localStorage.getItem('examinerId'),10) && !is_feedback_by_examiner2) ||
                    (codeExaminerId==parseInt(localStorage.getItem('examinerId'),10) && !is_feedback_by_code_examiner))
                     &&
                    <div className="editButton"><Link to={{pathname: `/feedbacks/newe/${id}`}} style={{textDecoration:"none" }}>Give Feedback</Link></div>}

                    {((reviewer_id1==parseInt(localStorage.getItem('examinerId'),10) && is_feedback_by_reviewer1) ||
                    (reviewer_id2==parseInt(localStorage.getItem('examinerId'),10) && is_feedback_by_reviewer2)||
                    (examiner_id1==parseInt(localStorage.getItem('examinerId'),10) && is_feedback_by_examiner1) ||
                    (examiner_id2==parseInt(localStorage.getItem('examinerId'),10) && is_feedback_by_examiner2) ||
                    (codeExaminerId==parseInt(localStorage.getItem('examinerId'),10) && is_feedback_by_code_examiner))
                     &&
                    <div className="editButton">Feedback Given</div>}


                      {((reviewer_id1==parseInt(localStorage.getItem('examinerId'),10) && is_feedback_by_reviewer1) ||
                    (reviewer_id2==parseInt(localStorage.getItem('examinerId'),10) && is_feedback_by_reviewer2)||
                    (examiner_id1==parseInt(localStorage.getItem('examinerId'),10) && is_feedback_by_examiner1) ||
                    (examiner_id2==parseInt(localStorage.getItem('examinerId'),10) && is_feedback_by_examiner2) ||
                    (codeExaminerId==parseInt(localStorage.getItem('examinerId'),10) && is_feedback_by_code_examiner))
                     &&
                  <div className="viewButton"><Link
  to={`/feedbacks/view-feedback/${feedbackId}`}
  state={{ from: location.pathname }}
>View</Link></div>}

                            {((reviewer_id1==parseInt(localStorage.getItem('examinerId'),10) && is_feedback_by_reviewer1) ||
                    (reviewer_id2==parseInt(localStorage.getItem('examinerId'),10) && is_feedback_by_reviewer2)||
                    (examiner_id1==parseInt(localStorage.getItem('examinerId'),10) && is_feedback_by_examiner1) ||
                    (examiner_id2==parseInt(localStorage.getItem('examinerId'),10) && is_feedback_by_examiner2) ||
                    (codeExaminerId==parseInt(localStorage.getItem('examinerId'),10) && is_feedback_by_code_examiner)) && !share_to_student
                     &&           <div className="editButton"><Link to={`/feedbacks/edit-feedback/${feedbackId}`} state={{ from: location.pathname }} >Edit</Link></div>}

                {((reviewer_id1==parseInt(localStorage.getItem('examinerId'),10) && is_feedback_by_reviewer1) ||
                    (reviewer_id2==parseInt(localStorage.getItem('examinerId'),10) && is_feedback_by_reviewer2)||
                    (examiner_id1==parseInt(localStorage.getItem('examinerId'),10) && is_feedback_by_examiner1) ||
                    (examiner_id2==parseInt(localStorage.getItem('examinerId'),10) && is_feedback_by_examiner2) ||
                    (codeExaminerId==parseInt(localStorage.getItem('examinerId'),10) && is_feedback_by_code_examiner)) && share_to_student
                     &&
                    <div className="editButton">Feedback Shared with Student</div>}


                </div>
            );
        }
    }]

   {/* const viewColumn = [{ field: "view", headerName:"All Feedbacks", width:120,
      renderCell:(params)=>{
          const { id ,student_id,reviewer_id1, reviewer_id2,is_feedback_by_reviewer1,is_feedback_by_reviewer2,examiner_id1, examiner_id2,is_feedback_by_examiner1,is_feedback_by_examiner2} = params.row;
          return(
              <div className="cellAction">
                  <div className="viewButton"><Link to={{pathname: `view-feedbacks/${student_id}`}}>View</Link></div>
                  
              </div>
          );
      }
  }] */}

  
  
                      

    const handleFileChange = (event) => {
        setFile(null);
        const selectedFile = event.target.files[0];
        const maxFileSize = 10 * 1024 * 1024; // 10 MB
        const allowedTypes = [
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
          'application/vnd.ms-excel', // .xls
          'text/csv' // .csv
        ];

        if (selectedFile.size > maxFileSize) {
          toast.error('File size exceeds 10 MB limit');
          return;
        }

        if (!allowedTypes.includes(selectedFile.type)) {
          toast.error('Only Excel (.xlsx, .xls) and CSV (.csv) files are allowed');
          return;
        }
        setFile(selectedFile);
    };

    
    const handleSubmit = async (event) => {
        event.preventDefault();

        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await axiosInstance.post('/uploadThesis', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                showToastOnResponse: true
            });

           // console.log(response.data); 
            fetchThesis();// Handle success response
        } catch (error) {
            console.error('Error uploading file:', error); // Handle error response
        }
    };

    const myVivaIds = thesis
    .map(s => s.vivaId)
    .filter(Boolean);

    return (
        <div className="datatable" >
        <div className="datatableTitle">
            {showSlotButton && <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 4 }}>
                <Link
                    to={{ pathname: `/examiner/edit-vivaSlot/${examinerId}` }}
                    style={{
                        textDecoration: "none",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 6,
                        padding: "6px 14px",
                        background: "#1976d2",
                        color: "#fff",
                        borderRadius: 6,
                        fontWeight: 600,
                        fontSize: 14,
                        boxShadow: "0 0 0 3px rgba(25,118,210,0.25)",
                        animation: "vivaSlotPulse 2s ease-in-out infinite",
                        cursor: "pointer",
                    }}
                    title="Click here to submit your viva slot preferences"
                >
                    &#128197; Submit Viva Slot Preferences
                </Link>
                <span style={{ fontSize: 11, color: "#1976d2", fontWeight: 500, paddingLeft: 2 }}>
                    Click above to submit your viva slot preferences
                </span>
            </div>}
            <div>Assigned Thesis List</div>
        </div>
      
      <DataGrid 
      rows={thesis}
      //columns={columns.concat(viewColumn).concat(actionColumn)}
      columns={columns.concat(actionColumn)}
      initialState={{
        pagination: {
          paginationModel: { page: 0, pageSize: 10 },
        },
      }}
      pageSizeOptions={[5, 10]}
      //checkboxSelection
    />
    <div>
        {enrichedSlots
          .filter(slot => isSlotActive(slot) &&
          slot.vivaIds?.some(id => myVivaIds.includes(id))
        )
          .map((slot, index) => (
            <VivaChatWidget
              key={index}
              slot={slot}
              index={index}
              role="EXAMINER"
            />
          ))}
        </div>
  </div>
    );
}

